// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COUNSELLING_ALL_TOPICS = "V\u0161echny poradny";
export const COUNSELLING_ARCHIVED_TOPICS = "Archiv poraden";
export const COUNSELLING_NEWEST_RESPONSES = "Nejnov\u011bj\u0161\u00ed zodpov\u011bzen\u00e9 ot\u00e1zky";
export const COUNSELLING_OTHER_TOPICS = "Ostatn\u00ed poradny";
export const COUNSELLING_OUR_EXPERTS_HELPED_num_MOTHERS = "Na\u0161i odborn\u00edci u\u017e poradili %(num)s mamink\u00e1m";
export const COUNSELLING_SEARCH_COUNSELLINGS_PLACEHOLDER = "Hledej v poradn\u00e1ch...";
export const COUNSELLING_SEARCH_COUNSELLINGS_RESULT_query_count = ["%(count)s p\u0159\u00edsp\u011bvek pro \"%(query)s\" v poradn\u00e1ch.", "%(count)s p\u0159\u00edsp\u011bvky pro \"%(query)s\" v poradn\u00e1ch.", "%(count)s p\u0159\u00edsp\u011bvk\u016f pro \"%(query)s\" v poradn\u00e1ch."];
export const COUNSELLING_TOPICS_I_AM_FOLLOWING = "Poradny, kter\u00e9 odeb\u00edr\u00e1m";
export const TOPIC_MODERATOR = "Moder\u00e1tor";
